import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useState } from "react";
import { useHomeContext } from "../../../context/HomeContext";
import { FaTimes } from "react-icons/fa";
import { useThemeContext } from "../../../context/ThemeContext";
import AddRealEstateForm from "./AddRealEstateForm";
const AddRealEstateModal = ({ isModalOpen, setIsModalOpen, editId, setEditId }) => {
  const { currentMode } = useThemeContext();
  const panelLight =
    " w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-3 text-left align-middle shadow-xl transition-all";
  const panelDark =
    "w-full max-w-md transform overflow-hidden rounded-2xl bg-secondary-dark-bg p-3 text-left align-middle shadow-xl transition-all";

  const handleClose = () => {
    setIsModalOpen(false);
    setTimeout(() => {
      setEditId(null);
    }, 500);
  };
  return (
    <>
      <Transition appear show={isModalOpen} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-50"
          onClose={() => setIsModalOpen(true)}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel
            className={currentMode === "Dark" ? panelDark : panelLight}
                >
                  <div
                    onClick={handleClose}
                    className={`absolute right-3 top-2 border-2 rounded-md ${
                      currentMode === "Dark"
                        ? "dark:border-gray-400 "
                        : "border-[#216fed] "
                    } p-1 cursor-pointer`}
                  >
                    <FaTimes
                      size={15}
                      style={{
                        color: currentMode === "Dark" ? "#fff" : "#216fed",
                      }}
                    />
                  </div>
                  <AddRealEstateForm
                    setIsModalOpen={setIsModalOpen}
                    editId={editId}
                    setEditId={setEditId}
                  />
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default AddRealEstateModal;
